export const command = {
  openMenu: 'Menu',
  search: 'Wpisz komendę albo szukaj',
  noResults: 'Brak rezultatów',
  actions: 'Akcje',
  manage: 'Zarządanie',
  simulation: 'Symulacja',
} as const
